import { render, staticRenderFns } from "./vpd-consent-account-panel.vue?vue&type=template&id=537a96fa"
import script from "./vpd-consent-account-panel.vue?vue&type=script&lang=js"
export * from "./vpd-consent-account-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports